import React from "react";

const Terms = () => {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Terms of Service</h1>
      <p>Last updated: April 2025</p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to ChiSquareAI. These Terms of Service ("Terms") govern your
        use of our platform, services, and products. By accessing or using our
        services, you agree to be bound by these Terms.
      </p>

      <h2>2. Services Provided</h2>
      <p>
        ChiSquareAI provides predictive analytics and sales forecasting tools
        based on AI models. We connect with third-party platforms (e.g., Stripe,
        Twitter, Reddit, YouTube) to retrieve data and generate insights.
      </p>

      <h2>3. User Accounts</h2>
      <p>
        To access certain features, you may need to create an account and
        provide accurate and complete information. You are responsible for
        maintaining the confidentiality of your account credentials.
      </p>

      <h2>4. Acceptable Use</h2>
      <p>
        You agree not to misuse the platform, including attempting to gain
        unauthorized access, scraping, reverse engineering, or any illegal
        activity.
      </p>

      <h2>5. Data Usage</h2>
      <p>
        By connecting third-party accounts (e.g., Stripe), you grant permission
        for ChiSquareAI to access and process your data to generate predictions
        and analytics. We do not sell or share your data without your
        permission.
      </p>

      <h2>6. Payments</h2>
      <p>
        If you subscribe to a paid plan, you agree to pay the applicable fees.
        Payments are processed securely through third-party platforms (e.g.,
        Stripe).
      </p>

      <h2>7. Termination</h2>
      <p>
        We may suspend or terminate your account if you violate these Terms or
        engage in harmful behavior. You may also terminate your account at any
        time.
      </p>

      <h2>8. Disclaimers</h2>
      <p>
        Our services are provided "as is" without warranties. We are not liable
        for indirect or consequential damages from using the platform.
      </p>

      <h2>9. Changes to Terms</h2>
      <p>
        We may update these Terms periodically. Any changes will be posted on
        this page, and your continued use of the platform implies acceptance of
        the updated Terms.
      </p>

      <h2>10. Contact</h2>
      <p>
        If you have any questions, contact us at support@chisquare.io.
      </p>
    </div>
  );
};

export default Terms;